import { h, VNode } from 'preact';
import * as styles from './some-component.component.scss';
import { withText } from 'preact-i18n';

type SomeComponentProps = {
  someTitle: string;
  greetingTxt?: string;
};

function SomeComponent({ greetingTxt, someTitle }: SomeComponentProps): VNode {
  return (
    <div className={styles.someComponent}>
      <span>
        {greetingTxt} {someTitle}
      </span>
    </div>
  );
}

const SomeWrappedComponent = withText({ greetingTxt: 'dummy.greeting' })(SomeComponent);

export { SomeWrappedComponent };
